import { render, staticRenderFns } from "./allowedDates.vue?vue&type=template&id=8cd82976&scoped=true&"
import script from "./allowedDates.vue?vue&type=script&lang=js&"
export * from "./allowedDates.vue?vue&type=script&lang=js&"
import style0 from "./allowedDates.vue?vue&type=style&index=0&id=8cd82976&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd82976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
